var _style, _g, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVleagueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "120px",
    height: "30px",
    viewBox: "0 0 120 30",
    style: {
      enableBackground: "new 0 0 120 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C3078;}\n\t.st1{fill:#D94D4D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.1,6.3 13.3,2.8 118.9,4.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.7,21.6h-7.5l0.5-3.2h7.5L22.7,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.4,26.8H25l3.2-18h4.5l-2.5,14.1H37L36.4,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.9,26.8H38.4l3.2-18h12.5l-0.7,3.9h-8l-0.6,3.4h6.6L50.7,20h-6.6l-0.5,2.9h8L50.9,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76,27.2c-2.4,0-4-0.5-4.9-1.7c-0.6-0.8-0.9-1.8-0.9-3.2c0-0.6,0.1-1.3,0.2-2l0.9-5c0.8-4.5,3.5-6.7,8.2-6.7 c1.9,0,3.4,0.4,4.4,1.2c1,0.8,1.5,1.9,1.5,3.4c0,0.6-0.1,1.2-0.3,1.8c-0.1,0.6-0.3,1-0.5,1.4l-0.3,0.5H80c0.4-0.6,0.6-1.3,0.6-2.1 c0-1.5-0.6-2.3-1.9-2.3c-1.7,0-2.7,1-3,2.9l-0.9,4.8c-0.1,0.5-0.1,0.9-0.1,1.3c0,1.1,0.7,1.7,2,1.7c1.4,0,2.2-0.7,2.6-2h-2 l0.5-2.8h6.6l-0.4,2.2L84,21.4C83.3,25.3,80.6,27.2,76,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.4,25.5c-1.3,1.1-3.2,1.7-5.6,1.7c-2.4,0-4.1-0.6-5-1.7c-0.7-0.8-1-1.8-1-3.2c0-0.6,0.1-1.3,0.2-2l2-11.5 h4.5l-2,11.4c-0.1,0.4-0.1,0.9-0.1,1.3c0,1.1,0.7,1.8,2.1,1.8c0.8,0,1.5-0.2,2-0.6c0.5-0.4,0.9-1.2,1-2.4l2-11.4h4.5l-2,11.5 C100.6,22.7,99.7,24.4,98.4,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.7,26.8h-12.5l3.2-18h12.5l-0.7,3.9h-8l-0.6,3.4h6.6l-0.7,3.9h-6.6l-0.5,2.9h8L115.7,26.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,22.5l4.7-13.6h4.9l-6.8,18h-8l-0.2-18h4.9L5.9,22.5H6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.8,13.2l-4.7,13.6h-4.9l6.8-18h8l0.2,18h-4.9l0.1-13.6H62.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.1,6.1 12.2,6.1 10.2,11.8 15,11.8  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "118.9,4.1 118.9,4.8 87.7,5 87.7,4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVleagueLogo);
export default __webpack_public_path__ + "static/media/vleague-logo.0ef33b234674dfd263b505427caaa97c.svg";
export { ForwardRef as ReactComponent };